module.exports = __webpack_public_path__ + "img/downBack.db57ec03.png";